import { Routes } from '@angular/router';
import { EntitiesComponent } from './entities.component';

export const entityRoutes: Routes = [
    {
        path:       '',
        component:  EntitiesComponent
    },
];
